import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { ZariContext } from '_zari/context'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const IdDistritoFormGroup = ({ idProvincia, values, iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const [distritos, setDistritos] = React.useState([])

  React.useEffect(() => {
    setDistritos([])
    if (idProvincia !== '') {
      TablaComunService.getAsSelect(TiposTablaComunConstant.DISTRITO, { _idProvincia: idProvincia })
        .then(({ data }) => setDistritos(data))
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }, [__zariContext, idProvincia])

  return (
    <Form.Group>
      <Form.Label text='DISTRITO' htmlFor='select-idDistrito' md={2} />
      <Col md={10}>
        <Field name='_idDistrito'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-idDistrito'
            >
              <option value=''>Seleccionar</option>
              {distritos.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdDistritoFormGroup)
